export default data => {
  return data.replace(/ src=/g, ' data-src=');
};
